import React, { useEffect, useRef, memo } from 'react';
import ChatItem from './ChatItem';

const ChatList = memo(({ chats, selectedChat, onChatSelect, onLoadMore, hasMore, isLoading, hasActiveFilters, onClearFilters, botTimezones }) => {
  const listRef = useRef(null);
  
  // Scroll infinito para cargar más chats
  useEffect(() => {
    const container = listRef.current; // El scroll está en chat-list, no en su padre
    if (!container || !hasMore || isLoading) return;
    
    const handleScroll = () => {
      const scrollTop = container.scrollTop;
      const scrollHeight = container.scrollHeight;
      const clientHeight = container.clientHeight;
      
      // Cargar más cuando esté cerca del final (100px antes)
      if (scrollHeight - scrollTop - clientHeight < 100) {
        console.log('📜 Scroll cerca del final, cargando más chats...');
        onLoadMore();
      }
    };
    
    container.addEventListener('scroll', handleScroll, { passive: true });
    return () => container.removeEventListener('scroll', handleScroll);
  }, [hasMore, isLoading, onLoadMore]);
  
  console.log(`🔄 RENDERIZANDO ChatList: ${chats.length} chats`);
  
  const showEmptyState = !isLoading && chats.length === 0;
  
  return (
    <div className="chat-list" ref={listRef}>
      {chats.map(chat => {
        // ✅ CRÍTICO: Key única incluyendo botId para evitar mezclar chats de diferentes bots
        const uniqueKey = chat.botId ? `${chat.chatId}_bot_${chat.botId}` : chat.chatId;
        // ✅ CRÍTICO: Verificar tanto chatId como botId para selección
        const isChatSelected = selectedChat && 
          selectedChat.chatId === chat.chatId &&
          (!selectedChat.botId || !chat.botId || Number(selectedChat.botId) === Number(chat.botId));
        
        const botTimezone = (botTimezones && chat.botId != null)
          ? botTimezones[String(chat.botId)]
          : undefined;

        return (
          <ChatItem
            key={uniqueKey}
            chat={chat}
            isSelected={isChatSelected}
            onChatSelect={onChatSelect}
            botTimezone={botTimezone}
          />
        );
      })}
      {showEmptyState && hasActiveFilters && (
        <div className="chat-list-empty">
          <div className="chat-list-empty-title">Sin resultados</div>
          <div className="chat-list-empty-text">
            Ningún chat coincide con los criterios de búsqueda.
          </div>
          {onClearFilters && (
            <button className="chat-list-empty-action" type="button" onClick={onClearFilters}>
              Quitar filtros
            </button>
          )}
        </div>
      )}
      {showEmptyState && !hasActiveFilters && (
        <div className="chat-list-empty">
          <div className="chat-list-empty-text">No hay chats todavía.</div>
        </div>
      )}
      {isLoading && (
        <div style={{ 
          padding: '10px', 
          textAlign: 'center', 
          color: '#666',
          fontSize: '0.9rem'
        }}>
          Cargando más chats...
        </div>
      )}
      {!hasMore && chats.length > 0 && (
        <div style={{ 
          padding: '10px', 
          textAlign: 'center', 
          color: '#999',
          fontSize: '0.85rem'
        }}>
          No hay más chats
        </div>
      )}
    </div>
  );
});

export default ChatList;
